import React from 'react'
import api from 'src/api/api'

const basePath = String(process.env.PUBLIC_URL).trim()
const Inicio = React.lazy(() => import('./views/sitio/home/Home'))
const PaginaFull = React.lazy(() => import('./views/sitio/PaginaFull'))
const PaginaMenu = React.lazy(() => import('./views/sitio/PaginaMenu'))
const Noticias = React.lazy(() => import('./views/sitio/Noticias'))
const Noticia = React.lazy(() => import('./views/sitio/Noticia'))

const routesSitios = api
  .sitios()
  .then((res) => {
    let sitiosApi = []
    res.data.data.map((_sitio) => {
      sitiosApi.push(
        ...[
          {
            to: basePath + _sitio.url + '/inicio',
            exact: true,
            name: _sitio.descripcion,
            component: Inicio,
          },
          {
            to: basePath + _sitio.url + '/noticias',
            exact: true,
            name: 'Noticias',
            component: Noticias,
          },
          {
            to: basePath + _sitio.url + '/noticias/:id',
            exact: false,
            name: 'Noticia',
            component: Noticia,
          },
          {
            to: basePath + _sitio.url + '/ps/:ruta/:id',
            exact: false,
            name: 'Página',
            component: PaginaMenu,
          },
          {
            to: basePath + _sitio.url + '/pf/:ruta/:id',
            exact: false,
            name: 'Página',
            component: PaginaFull,
          },
          {
            to: basePath + _sitio.url,
            exact: true,
            name: _sitio.descripcion,
            component: () => (window.location.href = basePath + _sitio.url + '/inicio'),
          },
          /* {
            to: basePath + _sitio.url + '*',
            exact: false,
            name: _sitio.descripcion,
            component: () => (window.location.href = basePath + _sitio.url + '/error404'),
          }, */
        ],
      )
    })
    return sitiosApi
  })
  .catch((error) => {
    /* console.log(error) */
  })

export default routesSitios
